<template>
  <EnvBadge />
  <PageLoader />
  <router-view />
  <CookieDialog />
</template>

<script setup>
import EnvBadge from '@shared/components/EnvBadge.vue'
import PageLoader from '@shared/components/Pageloader.vue'
import Tracker from '@shared/Tracker'
import { changeLocale } from '@shared/localization'
import { computed, watch } from 'vue'
import { getLangCodeByLanguage, setPageTitle } from '@shared/utils'
import { useI18n } from 'petite-vue-i18n'
import useUserStore from '@shared/stores/useUserStore.js'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import CookieDialog from '@us/app/components/CookieDialog.vue'
import * as apiRequest from '@shared/api-endpoints'

const { t } = useI18n()
const userStore = useUserStore()
const corporateStore = useCorporateStore()

const lang = computed(() => userStore.lang)
const user = computed(() => userStore.user)

// update the i18n language whenever the language in the store changes
watch(
  lang,
  (lang) => {
    changeLocale(getLangCodeByLanguage(lang), document.documentElement)
    // reload translations for the corporate
    if (corporateStore.corporate) {
      apiRequest.loadCorporate({
        key: corporateStore.corporate.key,
      })
    }
  },
  { immediate: true },
)

watch(user, (user) => Tracker.setUser(user), {
  immediate: true,
})

setPageTitle(t('b2b__landing_page__generic__page_title'))
</script>
